import { render, staticRenderFns } from "./RelationshipUpdate.vue?vue&type=template&id=f077c3b2&"
import script from "./RelationshipUpdate.vue?vue&type=script&lang=js&"
export * from "./RelationshipUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports